module.exports = __webpack_public_path__ + "img/img10.e2b74ebd.svg";